import { serverBackend } from '../hooks/serverAxios';
import { clientAPI } from './client';
export * from './user.types';

export const loginUser = async (address: string, signature: string) => {
  const res = await clientAPI.post('/user/login', { address, signature });
  return res.data;
};

export const getUser = async (token: string) => {
  const res = await clientAPI.get('/user/me', {
    headers: { Authorization: JSON.stringify({ token }) },
  });
  return res.data;
};

export const getUserByAddress = async (address: string) => {
  try {
    console.log(`/user/byAddress/${address}`)
  const res = await serverBackend.get(`/user/byAddress/${address}`);

  return res.data;

  } catch (error) {
    console.error('Error fetching user by address:', error);
    throw error;
  }
};

export const updateUserProfile = async (
  data: Record<string, unknown>,
  avatarFile: File | null = null,
) => {
  const formData = new FormData()

  if (avatarFile) {
    formData.append('avatar', avatarFile)
  }


  Object.entries(data).forEach(([key, value]) => {
    if (key === 'avatar') return     
    if (value === undefined || value === null) return

    formData.append(key, typeof value === 'string' ? value : JSON.stringify(value))
  })



  const res = await clientAPI.post('/user/update', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data
}

export const followUser = async (token: string, followedId: number) => {
  const res = await clientAPI.post('/follow/user', { followedId }, {
    headers: { Authorization: JSON.stringify({ token }) },
  });
  return res.data;
};

export const unfollowUser = async (token: string, followedId: number) => {
  const res = await clientAPI.post('/follow/user/unfollow', { followedId }, {
    headers: { Authorization: JSON.stringify({ token }) },
  });
  return res.data;
};

export const followToken = async (token: string, tokenId: number) => {
  const res = await clientAPI.post('/follow/token', { tokenId }, {
    headers: { Authorization: JSON.stringify({ token }) },
  });

  return res.data;
};

export const unfollowToken = async (token: string, tokenId: number) => {
  const res = await clientAPI.post('/follow/token/unfollow', { tokenId }, {
    headers: { Authorization: JSON.stringify({ token }) },
  });
  return res.data;
};
